import { Button } from "Components/Button";

import { ProductAdded } from "Requests/Partners/PreBudgets";
import { formatBRLCurrency } from "Utils/FormatCurrency";

interface CartItemProps {
  product: ProductAdded;
  addUnitItem: (productId: number) => void;
  removeUnitItem: (productId: number) => void;
  deleteItem: (productId: number) => void;
  loadingOp: boolean;
  blockedUserInteraction?: boolean;
}

export const CartItem = ({
  product,
  addUnitItem,
  loadingOp,
  removeUnitItem,
  blockedUserInteraction,
  deleteItem,
}: CartItemProps) => {
  const handleDecreaseQuantity = () => {
    if (product.amount <= 1) {
      deleteItem(product.product_id);
    } else {
      removeUnitItem(product.product_id);
    }
  };

  return (
    <div className="cart-item">
      <p className="label">
        {product.product_code && `${product.product_code} | `}{" "}
        {product.product_name}{" "}
      </p>
      <div className="action">
        <div className="amount space-buttons">
          <Button
            loading={loadingOp}
            type="button"
            onClick={handleDecreaseQuantity}
            textButton
            disabled={blockedUserInteraction}
          >
            -
          </Button>

          <span className="_number product-quantity">{product.amount}</span>

          <Button
            loading={loadingOp}
            type="button"
            onClick={() => addUnitItem(product.product_id)}
            textButton
            disabled={blockedUserInteraction}
          >
            +
          </Button>
        </div>
        <p className="price unit">
          R$ {formatBRLCurrency(product.amount * product.product_price)}
        </p>
      </div>
    </div>
  );
};
